export const environment: any = {
  production: true,
  tenantId: '#{AzureAD.Tenant.Id}',
  clientId: '#{AzureAD.Client.Id}',
  environment: '#{Environment}',
  subEnvironment: '#{SubEnvironment}',
};
